import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost' | 'dark';
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  ...props 
}) => {
  const baseStyles = "px-6 py-3 rounded-lg text-sm font-semibold transition-all duration-200 flex items-center justify-center gap-2 tracking-wide active:scale-95";
  
  const variants = {
    primary: "bg-clever-teal text-white hover:bg-red-700 shadow-lg shadow-red-500/20 border border-transparent",
    // Updated to Rabbit Navy (#0B1121)
    dark: "bg-[#0B1121] text-white hover:bg-[#1a253a] shadow-lg border border-transparent",
    outline: "bg-transparent border border-gray-300 text-gray-900 hover:border-clever-teal hover:text-clever-teal",
    ghost: "bg-transparent text-gray-500 hover:text-clever-teal hover:bg-red-50 border border-transparent"
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
